import React from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
// import App from './DummyApp2'
import App from './App'

if (process.env.NODE_ENV === 'prod') {
  const noop = () => {
    // do nothing
  }
  console.log = noop
  console.info = noop
  console.warn = noop
  console.error = noop
  console.debug = noop
}

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(<App />)
